import { userAuthAPI } from "../api/requests/users/userAuthAPI";
import { tokenHandler } from "./authStore";

export default async function handleSignOut() {
    const refreshToken = tokenHandler.get('refreshToken');
    try {
        await userAuthAPI.signOut(refreshToken);
    } catch(error) {
        console.error(error);
    } finally {
        localStorage.clear();
        tokenHandler.remove('accessToken');
        tokenHandler.remove('refreshToken')
        window.location = '/sign-in'
    }
}